module.exports = __webpack_public_path__ + "static/media/sw4t-profile.737e7d22.webp";